// import React, { useState, useMemo, useEffect } from 'react';
// import { matchPath, Outlet, useLocation, useNavigate } from 'react-router-dom';
// import { Bell } from 'lucide-react';
// import { useHeaderAction } from '../../../core/provider/HeaderActionProvider/HeaderAction.js';
// import BottomNavigation from '../../ui/BottomNavigation/index.js';
// import { CUSTOMER_NAV_ITEMS, LEGAL_NAV_ITEMS } from '../../../core/constants/navigationItems.js';
// import { toastify } from '../../ui/Toasts/index.js';
// import { useAuth } from '../../../core/provider/Auth/index.js';
// import { shouldHideFooter } from '../../../lib/shouldHideFooter.js';

// interface MainLayoutProps {
//     showFooter?: boolean;
//     navItems?: Array<{
//         icon: React.ReactNode;
//         label: string;
//         path: string;
//     }>;
// }

// // ===== تابع کمکی برای دریافت کوکی =====
// const getCookie = (name: string): string | null => {
//     const match: any = document.cookie.match(
//         new RegExp('(^| )' + name + '=([^;]+)')
//     );
//     return match ? decodeURIComponent(match[2]) : null;
// };

// // ===== تابع کمکی برای تشخیص نقش کاربر =====
// const getUserRole = (): string => {
//     // اول localStorage چک کن
//     const localRole = localStorage.getItem("userRoleCartStreet");
//     if (localRole) return localRole;

//     // بعد کوکی
//     const cookieRole = getCookie("userRoleCartStreet");
//     if (cookieRole) return cookieRole;

//     // پیش‌فرض
//     return "customer";
// };
// export default function MainLayout({
//     navItems = []
// }: MainLayoutProps) {
//     const { action } = useHeaderAction();
//     const location = useLocation();
//     const navigate = useNavigate();
//     const { logout, refreshUser } = useAuth();

//     const [isLoggingOut, setIsLoggingOut] = useState(false);
//     const [isOpen, setIsOpen] = useState(false);

//     // ===== State برای نقش کاربر =====
//     const [userRole, setUserRole] = useState<string>(() => getUserRole());

//     // ===== چک کردن تغییر نقش در localStorage/کوکی =====
//     useEffect(() => {
//         const currentRole = getUserRole();
//         if (currentRole !== userRole) {
//             setUserRole(currentRole);
//         }
//     }, [location.pathname]);

//     // ===== انتخاب آیتم‌های نویگیشن =====
//     const currentNavItems = useMemo(() => {

//         if (userRole === "legal") {
//             return LEGAL_NAV_ITEMS;
//         }

//         return CUSTOMER_NAV_ITEMS;
//     }, [userRole]);

//     // ===== روت‌هایی که نباید فوتر داشته باشن =====
//     const noFooterRoutes = [
//         "/customer/profile/plans",
//         "/customer/profile/logout",
//         "/customer/payment/callback",
//         "/customer/profile/questions",
//         "/customer/loan/sell-diamond/request",
//         "/customer/benefit",
//         "/customer/revenues/import-excel",
//         "/customer/pos/form/device-select",
//         "/customer/revenues/register-marketer/visitor-request",
//         "/customer/profile/rules",
//         "/customer/profile/about",
//         "/customer/loan/transfer-loan",
//         "/customer/profile/editeProfile",
//         "/customer/revenues/customer-reports",
//         "/customer/charity/project/insert",
//         "/customer/revenues/register-marketer",
//         "/customer/revenues/register-marketer/additional-info",
//         "/customer/card-request",
//         "/customer/revenues/add-customer/registration-store",
//         "/customer/repots",
//         "/customer/revenues/add-customer",
//         "/customer/revenues/add-customer/data-bank",
//         "/customer/revenues/data-insurance",
//         "/customer/loan/request/no-diamonds/rules",
//         "/customer/loan/view",
//         "/customer/loan/request/no-diamonds",
//         "/customer/revenues/add-customer/insurance-type",
//         "/customer/loan/request",
//         "/customer/loan/shop-shopping/new-purchase",
//         "/customer/loan/request/no-diamonds/invoice",
//         "/customer/revenues/customer-reports/:id",
//         "/customer/pill/paymentId",
//         "/customer/pill/paymentBuy",
//         "/customer/loan/shop-shopping",
//         "/customer/insurance/elevator/select-insurance",
//         "/customer/insurance/elevator/support",
//         "/customer/loan/transfer-diamonds",
//         // "/customer/shop-panel",
//         "/customer/loan/convert-to-rial",
//         "/customer/loan/buy-diamond",
//         "/customer/revenues/legal-request-reports",
//         "/customer/loan/return-diamond",
//         "/customer/loan/transfer-diamond/request",
//         "/customer/revenues/data-shop",
//         "/customer/revenues/reports",
//         "/customer/insurance/third-insurance/select-insurance",
//         "/customer/insurance/building-insurance/support",
//         "/customer/insurance/building-insurance/select-insurance",
//         "/customer/insurance/third-insurance/support",
//         "/customer/revenues/add-customer/additional-info",
//         "/regulations",
//         "/customer/profile/teach",
//         "/customer/pill",
//         "/customer/games",
//         "/customer/revenues/insertComment/:id",
//         "/customer/incom-eneration",
//         "/customer/loan/donation-diamond",
//         "/customer/revenues/calculator",
//         "/customer/legal/charity/project/cash-withdrawal",
//         "/customer/insurance/body-insurance",
//         "/customer/insurance/motor-insurance",
//         "/customer/loan/payments-installments",
//         "/customer/legal/charity/diamonds",
//         "/customer/pos",
//         "/customer/shop-panel/request",
//         "/customer/loan/donation-diamond/:id",
//         "/customer/services/gold-box",
//         "/customer/services/bill",
//         "/customer/shop-panel/about",
//         "/customer/revenues/register-marketer/about"
//         // "/customer/insurance",
//         // "/customer/loan"
//     ];

//     // ===== هندلر خروج =====
//     const handleLogout = async () => {
//         setIsLoggingOut(true);
//         try {
//             logout();

//             // ✅ پاک کردن نقش کاربر
//             localStorage.removeItem("userRoleCartStreet");
//             document.cookie =
//                 "userRoleCartStreet=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";

//             setUserRole("customer");

//             toastify("success", "با موفقیت از حساب خود خارج شدید");
//             navigate('/login', { replace: true });
//             await refreshUser();
//         } catch (error) {
//             console.error("خطا در خروج:", error);
//             toastify("error", "خطا در خروج از حساب کاربری");
//         } finally {
//             setIsLoggingOut(false);
//             setIsOpen(false);
//         }
//     };

//     const showFooter = !shouldHideFooter(location.pathname, noFooterRoutes);


//     return (
//         <div className="w-full max-w-[450px] 3xl:max-w-[504px] h-dvh bg-gray-200 overflow-hidden relative flex flex-col rounded-none border-0 md:border border-gray-200 mx-auto">
//             <header className="h-10 shrink-0 bg-white flex items-center justify-between px-4 z-10">
//                 {!action ? (
//                     <>
//                         <div className='w-full flex justify-end'>
//                             <button className="relative p-2 hover:bg-gray-100 rounded-full transition-colors">
//                                 <Bell className="w-6 h-6 text-brand-700" />
//                             </button>
//                         </div>
//                     </>
//                 ) : (
//                     <div className="flex-1">{action}</div>
//                 )}
//             </header>

//             <main className="flex-1 min-h-0  overflow-y-auto no-scrollbar bg-white scroll-smooth">
//                 <div className={`${showFooter ? "pb-14" : "pb-4"} h-full p-2`}>
//                     <Outlet />
//                 </div>
//                 {showFooter && <BottomNavigation items={currentNavItems} />}
//             </main>
//         </div>
//     );
// }

import React, { useState, useMemo, useEffect } from 'react';
import { matchPath, Outlet, useLocation, useNavigate } from 'react-router-dom';
import { Bell } from 'lucide-react';
import { useHeaderAction } from '../../../core/provider/HeaderActionProvider/HeaderAction.js';
import BottomNavigation from '../../ui/BottomNavigation/index.js';
import {
    CUSTOMER_NAV_ITEMS,
    LEGAL_NAV_ITEMS,
    CHARITY_NAV_ITEMS,
    LEGAL_ONLY_NAV_ITEMS,
} from '../../../core/constants/navigationItems.js';
import { toastify } from '../../ui/Toasts/index.js';
import { useAuth } from '../../../core/provider/Auth/index.js';
import { shouldHideFooter } from '../../../lib/shouldHideFooter.js';
import { useUserInfo } from '../../../core/hooks/useUserInfo.js';

interface MainLayoutProps {
    showFooter?: boolean;
    navItems?: Array<{
        icon: React.ReactNode;
        label: string;
        path: string;
    }>;
}

// ===== تابع کمکی برای دریافت کوکی =====
const getCookie = (name: string): string | null => {
    const match: any = document.cookie.match(
        new RegExp('(^| )' + name + '=([^;]+)')
    );
    return match ? decodeURIComponent(match[2]) : null;
};

// ===== تابع کمکی برای تشخیص نقش کاربر =====
const getUserRole = (): string => {
    // اول localStorage چک کن
    const localRole = localStorage.getItem("userRoleCartStreet");
    if (localRole) return localRole;

    // بعد کوکی
    const cookieRole = getCookie("userRoleCartStreet");
    if (cookieRole) return cookieRole;

    // پیش‌فرض
    return "customer";
};

export default function MainLayout({
    navItems = []
}: MainLayoutProps) {
    const { action } = useHeaderAction();
    const location = useLocation();
    const navigate = useNavigate();
    const { logout, refreshUser } = useAuth();

    // ===== اطلاعات کاربر از API =====
    const { data: userInfoData } = useUserInfo();
    const userInfo = userInfoData?.payload;

    const [isLoggingOut, setIsLoggingOut] = useState(false);
    const [isOpen, setIsOpen] = useState(false);

    // ===== State برای نقش کاربر =====
    const [userRole, setUserRole] = useState<string>(() => getUserRole());

    // ===== چک کردن تغییر نقش در localStorage/کوکی =====
    useEffect(() => {
        const currentRole = getUserRole();
        if (currentRole !== userRole) {
            setUserRole(currentRole);
        }
    }, [location.pathname]);

    // ===== ✅ همگام‌سازی نقش با customerType واقعی API =====
    useEffect(() => {
        if (!userInfo) return;

        const realRole =
            userInfo?.customerType === "LEGAL" ? "legal" : "customer";

        if (realRole !== userRole) {
            setUserRole(realRole);
            localStorage.setItem("userRoleCartStreet", realRole);
            document.cookie = `userRoleCartStreet=${realRole}; path=/;`;
        }
    }, [userInfo, userRole]);

    // ===== ✅ انتخاب آیتم‌های نویگیشن =====
    const currentNavItems = useMemo(() => {
        // اگر navItems از پراپ پاس شده بود، اولویت دارد
        if (navItems && navItems.length > 0) {
            return navItems as any;
        }

        // اگر اطلاعات کاربر هنوز نیامده، از نقش ذخیره‌شده استفاده کن
        if (!userInfo) {
            if (userRole === "legal") return LEGAL_NAV_ITEMS;
            return CUSTOMER_NAV_ITEMS;
        }

        const isLegal = userInfo?.customerType === "LEGAL";
        const isCharity = userInfo?.legalInfo?.charity === true;

        // ✅ خیریه: legal + charity === true → با تب «پروژه‌ها»
        if (isLegal && isCharity) {
            return CHARITY_NAV_ITEMS;
        }

        // ✅ حقوقی بدون خیریه: legal + charity !== true → شبیه کاربر عادی
        if (isLegal && !isCharity) {
            return LEGAL_ONLY_NAV_ITEMS;
        }

        // ✅ حقیقی
        return CUSTOMER_NAV_ITEMS;
    }, [userInfo, userRole, navItems]);

    // ===== روت‌هایی که نباید فوتر داشته باشن =====
    const noFooterRoutes = [
        "/customer/profile/plans",
        "/customer/profile/logout",
        "/customer/payment/callback",
        "/customer/profile/questions",
        "/customer/loan/sell-diamond/request",
        "/customer/benefit",
        "/customer/revenues/import-excel",
        "/customer/pos/form/device-select",
        "/customer/revenues/register-marketer/visitor-request",
        "/customer/profile/rules",
        "/customer/profile/about",
        "/customer/profile/change-password",
        "/customer/loan/transfer-loan",
        "/customer/profile/editeProfile",
        "/customer/revenues/customer-reports",
        "/customer/charity/project/insert",
        "/customer/revenues/register-marketer",
        "/customer/revenues/register-marketer/additional-info",
        "/customer/card-request",
        "/customer/revenues/add-customer/registration-store",
        "/customer/repots",
        "/customer/revenues/add-customer",
        "/customer/revenues/add-customer/data-bank",
        "/customer/revenues/data-insurance",
        "/customer/loan/request/no-diamonds/rules",
        "/customer/loan/view",
        "/customer/loan/request/no-diamonds",
        "/customer/revenues/add-customer/insurance-type",
        "/customer/loan/request",
        "/customer/loan/shop-shopping/new-purchase",
        "/customer/loan/request/no-diamonds/invoice",
        "/customer/loan/convert-bon",
        "/customer/revenues/customer-reports/:id",
        "/customer/pill/paymentId",
        "/customer/pill/paymentBuy",
        "/customer/loan/shop-shopping",
        "/customer/insurance/elevator/select-insurance",
        "/customer/insurance/elevator/support",
        "/customer/loan/transfer-diamonds",
        // "/customer/shop-panel",
        "/customer/transactions",
        "/customer/loan/convert-to-rial",
        "/customer/loan/buy-diamond",
        "/customer/revenues/legal-request-reports",
        "/customer/loan/return-diamond",
        "/customer/loan/transfer-diamond/request",
        "/customer/revenues/data-shop",
        "/customer/revenues/reports",
        "/customer/insurance/third-insurance/select-insurance",
        "/customer/insurance/building-insurance/support",
        "/customer/insurance/building-insurance/select-insurance",
        "/customer/insurance/third-insurance/support",
        "/customer/revenues/add-customer/additional-info",
        "/regulations",
        "/customer/profile/teach",
        "/customer/pill",
        "/customer/games",
        "/customer/revenues/insertComment/:id",
        "/customer/incom-eneration",
        "/customer/loan/donation-diamond",
        "/customer/revenues/calculator",
        "/customer/legal/charity/project/cash-withdrawal",
        "/customer/insurance/body-insurance",
        "/customer/insurance/motor-insurance",
        "/customer/loan/payments-installments",
        "/customer/legal/charity/diamonds",
        "/customer/pos",
        "/customer/shop-panel/request",
        "/customer/loan/donation-diamond/:id",
        "/customer/services/gold-box",
        "/customer/services/bill",
        "/customer/shop-panel/about",
        "/customer/revenues/register-marketer/about"
        // "/customer/insurance",
        // "/customer/loan"
    ];

    // ===== هندلر خروج =====
    const handleLogout = async () => {
        setIsLoggingOut(true);
        try {
            logout();

            // ✅ پاک کردن نقش کاربر
            localStorage.removeItem("userRoleCartStreet");
            document.cookie =
                "userRoleCartStreet=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";

            setUserRole("customer");

            toastify("success", "با موفقیت از حساب خود خارج شدید");
            navigate('/login', { replace: true });
            await refreshUser();
        } catch (error) {
            console.error("خطا در خروج:", error);
            toastify("error", "خطا در خروج از حساب کاربری");
        } finally {
            setIsLoggingOut(false);
            setIsOpen(false);
        }
    };

    const showFooter = !shouldHideFooter(location.pathname, noFooterRoutes);

    return (
        <div className="w-full max-w-[450px] 3xl:max-w-[504px] h-dvh bg-gray-200 overflow-hidden relative flex flex-col rounded-none border-0 md:border border-gray-200 mx-auto">
            {!action ? (
                <>
                    {/* <div className='w-full flex justify-end'>
                            <button className="relative p-2 hover:bg-gray-100 rounded-full transition-colors">
                                <Bell className="w-6 h-6 text-brand-700" />
                            </button>
                        </div> */}
                </>
            ) : (
                <header className="h-10 shrink-0 bg-white flex items-center justify-between px-4 z-10">
                    <div className="flex-1">{action}</div>
                </header>
            )}

            {/* {action && (
                <header className="h-10 shrink-0 bg-white flex items-center justify-between px-4 z-10">
                    <div className="flex-1">{action}</div>
                </header>
            )} */}
            <main className="flex-1 min-h-0  overflow-y-auto no-scrollbar bg-white scroll-smooth">
                <div className={`${showFooter ? "pb-14" : "pb-4"} h-full p-2`}>
                    <Outlet />
                </div>
                {showFooter && <BottomNavigation items={currentNavItems} />}
            </main>
        </div>
    );
}